import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import "./CBOClubs.css";
import ClubMainPage from "../Club/ClubMainPage";
export default function CBOClubs() {
  const userTypes = ["CBO"];

  return (
    <>
      <UpdatesBanner
        className="cbo-club-banner-bg  text-white"
        bannerText="Join Clubs of your choice"
      />

      <div className="subSectionWrapper">
        <ClubMainPage type={userTypes} explore="club" />
      </div>
    </>
  );
}
